enum BillingsCargoOrderListingItemBillingType {
  PUB_CARGO_2_RAILY = "PUB_CARGO_2_RAILY",
  PRIV_CARGO_2_TAXI = "PRIV_CARGO_2_TAXI",
}

export default BillingsCargoOrderListingItemBillingType;
